import { Grid as MantineGrid, GridProps } from '@mantine/core';

export type IGridProps = GridProps;

/** @registry Design-layer pass-through over Mantine Grid; import this instead of @mantine/core Grid outside src/design. Compound statics (Grid.Col) are preserved. */
export const Grid = MantineGrid;
